import './App.css'
import {Route} from 'react-router-dom'
import BodyRouter from './components/BodyRouter';
import NavBar from './components/navigation/NavBar'
import Login from  './components/auth/Login'


function DataApp() {
  return (
    <div>
      <NavBar />
      {sessionStorage.getItem('token')?<BodyRouter />:<Login/>}
    </div>

  );
}

export default DataApp;